import type { JSX, ReactNode } from 'react';

export interface EmptyStateProps {
  /** Что именно пусто — одной фразой. */
  readonly title: string;
  /** Почему пусто и что с этим делать. */
  readonly hint?: string;
  /** Кнопка или ссылка на следующее осмысленное действие. */
  readonly action?: ReactNode;
  /** `card` — самостоятельный блок вместо списка, `inline` — заметка внутри панели. */
  readonly tone?: 'card' | 'inline';
}

/**
 * Пустое состояние списка: заголовок, объяснение и путь дальше.
 *
 * Отдельный компонент, а не строка в каждом экране, — чтобы пустой список
 * везде выглядел одинаково и нигде не оставался просто серой фразой (E15-T2).
 */
export function EmptyState({ title, hint, action, tone = 'card' }: EmptyStateProps): JSX.Element {
  if (tone === 'inline') {
    return (
      <div className="grid justify-items-start gap-1.5 text-sm text-[var(--kitup-color-muted)]">
        <p>{title}</p>
        {hint ? <p>{hint}</p> : null}
        {action}
      </div>
    );
  }

  return (
    <div className="kitup-empty">
      <p className="font-semibold text-[var(--kitup-color-ink)]">{title}</p>
      {hint ? <p className="max-w-prose text-sm text-[var(--kitup-color-muted)]">{hint}</p> : null}
      {action ? <div className="mt-1 flex flex-wrap justify-center gap-3">{action}</div> : null}
    </div>
  );
}
